import { render, staticRenderFns } from "./dlg_product_search.vue?vue&type=template&id=30b8141d&"
import script from "./dlg_product_search.vue?vue&type=script&lang=js&"
export * from "./dlg_product_search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports